export default "__VITE_ASSET__Dsh1SHg9__"